
import { Component, Vue } from 'vue-property-decorator'
import i18n from '@/i18n'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'

@Component({ i18n, components: { TeaserAccountTile } })
export default class RegistrationSuccessfulPage extends Vue {
  public url = ''
  private mounted() {
    if (this.$tc('registrationSuccessfulPage.primaryButtonText') !== 'registrationSuccessfulPage.primaryButtonText') {
      this.url = 'tel:' + this.$tc('registrationSuccessfulPage.primaryButtonText')
    }
  }
}
